export default __webpack_public_path__ + "static/media/commuter.5f2c96d7.jpg";